import { DateTimeWidget, ImageWidget, LanguageDropdownWidget, SelectWidget } from "./CustomWidgets"
import { DataProvider, ListComponent } from "../GenericList"

import LocationSelector from "../LocationSelector"
// import { LocationCustomWidget } from "./LocationCustomWidget"
import React from "react"
import { useParams } from "react-router-dom"
import CustomObjectFieldTabs from "./raffle/CustomObjectFieldTabs"
import { locationUISchema } from "react-ui-components/components/location/locationUISchema"
import { getFeaturedBusinessServicesPath } from "./featuredBusinessesPaths"
import { RaffleSelectWidget } from "./RaffleSelectWidget"

const getSortableNumber = (value: unknown, fallback: number) => {
  const numericValue = Number(value)
  return Number.isFinite(numericValue) ? numericValue : fallback
}

const sortByDateThenOrder = (first: any, second: any) => {
  const firstDate = getSortableNumber(first?.expirationDate ?? first?.createdDate, 0)
  const secondDate = getSortableNumber(second?.expirationDate ?? second?.createdDate, 0)

  if (firstDate !== secondDate) {
    return secondDate - firstDate
  }

  return getSortableNumber(first?.order, Number.MAX_SAFE_INTEGER) -
    getSortableNumber(second?.order, Number.MAX_SAFE_INTEGER)
}

interface ServiceFormData {
  value: any
  disabled: any
  showWinBox?: boolean
  location: {
    country: any
    province: any
    city: any
    street: any
    county: any
    zipCode: any
  }
}

const data = (featureBusiness?: boolean) => ({
  getListLocation(id: any) {
    return featureBusiness ? getFeaturedBusinessServicesPath(id) : ["sponsors", id, "services"]
  },
  EDIT_TITLE: "Edit Service",
  ADD_TITLE: "Add Sponsor",
  LOADING_MESSAGE: "Loading Service...",
  TITLE: "Service",
  IMAGES_BUCKET: "ServiceImages",
  prepareListData: (items: any[]) => [...items].sort(sortByDateThenOrder),

  onRowClick:
    (list: any, navigate: any) =>
    (arr: any, index: { dataIndex: any } /*: {rowIndex: number, dataIndex: number}*/) => {
      console.log("on row click----->", index.dataIndex)
      // const state = list[index.dataIndex]
      // const id = state.id
      // navigate(`/sponsors/${id}`, { state })
    },

  columnsProperties: [
    { hidden: true, name: "id", label: "Id" },
    { required: false, name: "disabled", default: false, label: "Disabled", type: "boolean" },
    {
      required: false,
      name: "expirationDate",
      label: "Expiration Date",
      type: "number",
      uiType: "datetime2",
    },

    { required: true, name: "name", label: "Name" },
    { required: true, name: "title", label: "Title" },
    { required: true, name: "linkUrl", label: "Link URL" },
    { required: true, type: "integer", name: "order", label: "Order" },
    { required: true, type: "string", name: "type", label: "Type" },
    { required: false, type: "number", name: "value", label: "Value" },
    { required: false, type: "string", name: "currency", label: "Currency" },
    { required: false, type: "string", name: "phoneNumber", label: "Phone Number" },
    { required: false, name: "showWinBox", default: true, label: "Show Win Box", type: "boolean" },
    { required: false, type: "string", name: "winBoxLabel", label: "Win Box Label" },
    {
      required: false,
      type: "string",
      name: "winBoxImageUrl",
      label: "Win Box Image",
      options: {
        customBodyRender: (value: string | undefined) => {
          return (
            <div className="flex flex-col flex-wrap overflow-auto w-40">
              {!value ? null : <img src={value} />}
            </div>
          )
        },
      },
    },
    {
      required: false,
      name: "winCouponPerLike",
      default: false,
      label: "Grant Coupon Per Win",
      type: "boolean",
    },
    {
      required: false,
      type: "string",
      name: "winRaffleId",
      label: "Raffle",
    },
    {
      required: false,
      type: "number",
      name: "winRaffleTicketsCount",
      default: 1,
      label: "Tickets Per Win",
    },
    {
      required: false,
      type: "number",
      name: "winMaxWinners",
      label: "Max Winners",
    },
    {
      required: false,
      type: "number",
      name: "winWinnersCount",
      label: "Winners",
      hideEdit: true,
    },

    {
      required: false,
      type: "string",
      name: "iconUrl",
      label: "Icon",

      options: {
        customBodyRender: (value: string | undefined) => {
          return (
            <div className="flex flex-col flex-wrap overflow-auto w-40">
              {!value ? null : <img src={value} />}
            </div>
          )
        },
      },
    },
    {
      type: "string",
      name: "image",
      label: "Image",
      options: {
        customBodyRender: (value: string | undefined) => {
          return (
            <div className="flex flex-col flex-wrap overflow-auto w-40">
              {!value ? null : <img src={value} />}
            </div>
          )
        },
      },
    },

    { required: false, name: "description", label: "Description" },
    { required: true, name: "language", label: "Language" },
    {
      required: false,
      name: "location",
      default: {
        country: "",
        province: "",
        city: "",
        street: "",
        county: "",
        zipCode: "",
      },

      type: "object",
      properties: {
        country: { type: "string", title: "Country" },
        province: { type: "string", title: "State" },
        city: { type: "string", title: "City" },
        street: { type: "string", title: "Street" },
        county: { type: "string", title: "County" },
        zipCode: { type: "string", title: "Zip Code" },
      },
      options: {
        customBodyRender: (value: {
          [x: string]:
            | string
            | number
            | boolean
            | React.ReactElement<any, string | React.JSXElementConstructor<any>>
            | Iterable<React.ReactNode>
            | React.ReactPortal
            | Iterable<React.ReactNode>
            | null
            | undefined
        }) => {
          return (
            <div className="flex flex-col flex-wrap overflow-auto w-40">
              {!value
                ? null
                : Object.keys(value).map((k) => {
                    return (
                      <label>
                        <b>{k}:</b>
                        {value[k]}
                      </label>
                    )
                  })}
            </div>
          )
        },
      },
    },
  ],

  uiSchema: {
    iconUrl: {
      "ui:widget": "image",
    },
    image: {
      "ui:widget": "image",
    },
    showWinBox: {
      "ui:options": { group: "Win Box" },
    },
    winBoxLabel: {
      "ui:options": { group: "Win Box" },
    },
    winBoxImageUrl: {
      "ui:widget": "image",
      "ui:options": { group: "Win Box" },
    },
    winCouponPerLike: {
      "ui:options": { group: "Win Box" },
    },
    winRaffleId: {
      "ui:widget": "raffleSelect",
      "ui:options": { group: "Win Box" },
    },
    winRaffleTicketsCount: {
      "ui:options": { group: "Win Box" },
    },
    winMaxWinners: {
      "ui:options": { group: "Win Box" },
    },
    winWinnersCount: {
      "ui:disabled": true,
      "ui:options": { group: "Win Box" },
    },
    // location: {
    //   "ui:widget": LocationCustomWidget,
    // },
    expirationDate: {
      "ui:widget": "datetime2",
    },
    description: {
      "ui:widget": "textarea",
    },
    language: {
      "ui:widget": LanguageDropdownWidget,
    },
    //  phoneNumber: {
    //   "ui:widget": ,
    // },
    location: {
      ...locationUISchema,
      // country: {
      //   "ui:widget": CountrySelectWidget,
      // },
      // province: {
      //   "ui:widget": StateSelectWidget,
      // },
      // city: {
      //   "ui:widget": CitySelectWidget,
      // },
    },
  },

  ObjectFieldTemplate: CustomObjectFieldTabs,

  async imageProcessor(
    fromData: { iconUrl: any; image: any; winBoxImageUrl?: any },
    handleUpload: (arg0: any, arg1: string, arg2: any) => any,
    id: any,
  ) {
    if (fromData.image) {
      fromData.image = await handleUpload(id, this.IMAGES_BUCKET, fromData.image)
    }

    if (fromData.iconUrl) {
      fromData.iconUrl = await handleUpload(id, this.IMAGES_BUCKET, fromData.iconUrl)
    } else if (fromData.image) {
      fromData.iconUrl = fromData.image
    }

    if (fromData.winBoxImageUrl) {
      fromData.winBoxImageUrl = await handleUpload(id, this.IMAGES_BUCKET, fromData.winBoxImageUrl)
    }

    return fromData
  },
  widgets: {
    LocationSelector,
    SelectWidget,
    image: ImageWidget,
    datetime2: DateTimeWidget,
    raffleSelect: RaffleSelectWidget,
  },
})

const Services = ({ onSuccess, featureBusiness }: {
  onSuccess?: () => void
  featureBusiness?: boolean
}) => {
  const { id } = useParams()
  return (
    <div>
      <DataProvider
        {...data(featureBusiness)}
        mainId={id}
        format={(data: ServiceFormData) => {
          return {
            ...data,
            value: data.value || "",
            disabled: !!data.disabled,
            showWinBox: data.showWinBox !== false,
            location: {
              ...data.location,
              country: data.location.country || "*",
              province: data.location.province || "*",
              city: data.location.city || "*",
              street: data.location.street || "*",
              county: data.location.county || "*",
              zipCode: data.location.zipCode || "*",
            },
          }
        }}
      >
        <ListComponent
          onSuccess={onSuccess}
          defaultAddData={{
            disabled: false,
            showWinBox: true,
          }}
        />
      </DataProvider>
    </div>
  )
}
export default Services
